import cn from 'classnames';
import {FC, ReactNode} from 'react';
import styles from './FormField.module.css';

type Props = {
	label: string;
	children: ReactNode;
	className?: string;
	/** Текст ошибки: подсвечивает подпись красным и выводит сообщение под полем. */
	error?: string | null;
	/**
	 * `label` — клик по подписи активирует единственный контрол.
	 * `div` — для группы контролов: иначе клик по подписи нажимает первую кнопку.
	 */
	as?: 'label' | 'div';
	/** id подписи, чтобы связать её с группой через aria-labelledby. */
	labelId?: string;
};

export const FormField: FC<Props> = ({label, children, className, error, as = 'label', labelId}) => {
	const Tag = as;

	return (
		<Tag className={cn(styles.root, className)}>
			<span id={labelId} className={cn(styles.label, error && styles.labelError)}>
				{label}
			</span>
			{children}
			{error ? <span className={styles.error}>{error}</span> : null}
		</Tag>
	);
};
